module.exports = __webpack_public_path__ + "static/media/cute-cartoon-dog-face-vector-14275452.95ae9b3d.jpg";